import { render } from "./About.vue?vue&type=template&id=e85dbaf2"
const script = {}
script.render = render

export default script